import axios from 'axios';
import { onAuthStateChanged } from 'firebase/auth';
import { jwtDecode } from 'jwt-decode';

import ENV from '../../app/constants/env';
import { setUserAccessToken } from '../../app/main/mainSlice';
import { store } from '../../app/store/store';
import { logout } from '../../components/authentication/auth.thunk';
import { getFbAuth } from '../../firebase/config';
import { checkOnlineStatus } from '../os.utils';

export const getFbUser = () =>
  new Promise((resolve) => {
    onAuthStateChanged(getFbAuth, (fbUser: any) => {
      resolve(fbUser);
    });
  });

export const isJwtExpired = (token: string | null) => {
  try {
    if (token) {
      const decoded = jwtDecode(token);
      if (!decoded.exp) {
        throw new Error('Token does not have an expiration time (exp)');
      }

      const currentTime = Date.now() / 1000;
      return decoded.exp <= currentTime;
    }
    throw new Error('User access token not present');
  } catch (error) {
    console.error('Error decoding token:', error);
    return true;
  }
};

export const fetchNewAccessToken = async (
  userId: string,
  refreshToken: string,
  fbUid: string
) => {
  try {
    const response = await axios.post(
      `${ENV.REGISTRATION_GCP_ENDPOINT}/generate-access-token-mob`,
      {
        mobRefreshToken: refreshToken,
        userHasuraId: userId,
        fireBaseUid: fbUid,
      }
    );

    const newAccessToken = response.data?.newAccessToken;
    if (!newAccessToken) throw new Error('Failed to refresh token');

    store.dispatch(setUserAccessToken({ newAccessToken }));
    return newAccessToken;
  } catch (error) {
    console.error('Error refreshing token:', error);
    const onlineStatus = await checkOnlineStatus();
    if (onlineStatus) {
      const isTokenExpired = true;
      store.dispatch(logout(isTokenExpired));
      window.location.href = '/sign-in';
    }
  }
};
